export default __webpack_public_path__ + "static/media/logo_regiojet.a9b4bfe6.svg";